import api from "@/lib/axiosConfig";
import {
  ExportConfigCreateDto,
  ExportConfigDto,
  ExportConfigUnparsedDto,
  ExportDataDto,
} from "@/lib/auth/export/export-types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const baseUrl = "back/api/export";

const exportData = async (exportDataDto: ExportDataDto) => {
  const response = await api.post(baseUrl, exportDataDto, {
    responseType: "blob",
  });
  return response;
};
export const useExportData = () => {
  return useMutation({ mutationFn: exportData });
};

const getExportConfigs = async (): Promise<ExportConfigDto[]> => {
  const { data } = await api.get<ExportConfigUnparsedDto[]>(
    `${baseUrl}/config`,
  );
  return data.map((config) => ({
    ...config,
    config: Object.values(JSON.parse(config.config)),
  }));
};
export const useGetExportConfigs = () => {
  return useQuery({
    queryKey: ["exportConfigs"],
    queryFn: getExportConfigs,
  });
};

const saveExportConfig = async (exportConfig: ExportConfigCreateDto) => {
  const payload = {
    ...exportConfig,
    config: JSON.stringify(exportConfig.config),
  } as const;
  const { data } = await api.post(`${baseUrl}/config`, payload);
  return data;
};
export const useSaveExportConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveExportConfig,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["exportConfigs"] });
    },
  });
};

const deleteExportConfig = async (id: string) => {
  const { data } = await api.delete(`${baseUrl}/config/${id}`);
  return data;
};
export const useDeleteExportConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteExportConfig,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["exportConfigs"] });
    },
  });
};
